<!-- Image Annotation Mode -->
@if (mediaTypeSignal() === MediaType.IMAGE && enableAnnotationSignal()) {
  <div
    class="media-container d-flex flex-column"
    [class.share-link-preview]="isShareLinkPreviewSignal()"
    [class.release-preview]="isReleasePreviewSignal()">
    <div class="d-flex align-items-center justify-content-center flex-fill">
      <mtm-image-annotation
        class="w-100 h-100"
        [projectId]="projectIdSignal()"
        [sectionId]="sectionIdSignal()"
        [subsectionId]="subsectionIdSignal()"
        [typeId]="typeIdSignal()"
        [item]="itemSignal()"
        [participants]="projectParticipantsSignal()"
        [hideAnnotationToolbar]="hideAnnotationToolbarSignal()"
        [annotations]="annotationsSignal()"
        [authUser]="userInfoSignal()"
        [hasEditPermission]="hasEditPermissionSignal()"
        [reviewLink]="subsectionStateSignal()?.reviewLink || null"
        [assetListTemplate]="assetListTemplate"
        [assetInfoTemplate]="assetInfoTemplate"
        [shareLinkPreview]="isShareLinkPreviewSignal()"
        [instanceId]="instanceIdSignal() ?? ''"
        [file]="itemSignal()">
      </mtm-image-annotation>
    </div>
  </div>
}

<!-- Non-Annotation Image Display -->
@if (
  (mediaTypeSignal() === MediaType.IMAGE || mediaTypeSignal() === MediaType.CONVERTIBLEIMAGE) &&
  !enableAnnotationSignal()
) {
  <div class="image-non-annotation d-flex flex-column">
    <div
      class="position-relative asset-container"
      [ngClass]="{ 'd-flex align-items-center justify-content-center': isKpfPreview }"
      [style.background-color]="'#000'">
      <div
        class="card-img card-background image-preview-element"
        [ngClass]="{
          'card-img-view': mode === 'view',
          '11rem': false,
          'img-cover': false,
          'min-h-250 h-100': isKpfPreview ? true : !portfolioPreviewSignal() && !enableResponsiveSignal(),
          'portfolio-preview': portfolioPreviewSignal(),
        }"
        [style.background-image]="imgSrcSignal()"
        (click)="showImageInNewTab()">
      </div>
      <ng-container [ngTemplateOutlet]="assetListTemplate"></ng-container>
      <ng-container [ngTemplateOutlet]="assetInfoTemplate"></ng-container>
    </div>
  </div>
}

@if (mediaTypeSignal() === MediaType.CONVERTIBLEIMAGE && itemSignal() && enableAnnotationSignal()) {
  <div class="w-100 h-100 min-h-250 media-container">
    @if (fileTranscodingStatusSignal() === FileTranscodingStatus.IN_PROGRESS || isLoadingSignal()) {
      <div
        class="w-100 h-100 min-h-250 d-flex flex-column align-items-center justify-content-center processing-container">
        <div class="loading-circle d-flex align-items-center justify-content-center flex-column">
          <span>{{ 'asset_processingFile' | translate }}</span>
          <span>{{ 'asset_pleaseWait' | translate }}</span>
        </div>
      </div>
    }

    @if (fileTranscodingStatusSignal() === FileTranscodingStatus.FAILED && !isLoadingSignal()) {
      <div class="w-100 h-100 min-h-250 d-flex flex-column office-failed">
        <mtm-pdf-transcode-error [file]="itemSignal()" [transcodingType]="TranscodingTypes.Png">
        </mtm-pdf-transcode-error>
      </div>
    }

    @if (fileTranscodingStatusSignal() === FileTranscodingStatus.SUCCESS) {
      <mtm-image-annotation
        class="w-100 h-100"
        [projectId]="projectIdSignal()"
        [sectionId]="sectionIdSignal()"
        [subsectionId]="subsectionIdSignal()"
        [typeId]="typeIdSignal()"
        [item]="itemSignal()"
        [hideAnnotationToolbar]="hideAnnotationToolbarSignal()"
        [participants]="projectParticipantsSignal()"
        [annotations]="annotationsSignal()"
        [authUser]="userInfoSignal()"
        [hasEditPermission]="hasEditPermissionSignal()"
        [reviewLink]="subsectionStateSignal()?.reviewLink || null"
        [assetListTemplate]="assetListTemplate"
        [assetInfoTemplate]="assetInfoTemplate"
        [shareLinkPreview]="isShareLinkPreviewSignal()"
        [instanceId]="instanceIdSignal() ?? ''"
        [file]="itemSignal()">
      </mtm-image-annotation>
    }
  </div>
}
